export default __webpack_public_path__ + "static/media/Ballroll_00342.9f3eb1e4.png";